import { Image } from '../../Image';

export function ColorVariantOption({
  color,
  enabledColorNameOnHover,
  onClick,
  onMouseEnter,
  swatchesMap,
  variantFromColor,
}) {
  const isActive = color === variantFromColor?.selectedOptionsMap.Color;
  const swatch = swatchesMap?.[color?.toLowerCase().trim()];
  const hasImage = swatch?.startsWith('http');
  const backgroundColor =
    isActive && swatch === '#FFFFFF'
      ? 'var(--off-white)'
      : swatch || 'var(--off-white)';

  return (
    <div className="group/color relative">
      <button
        aria-label={`Select ${color} color variant`}
        className={`relative flex h-6 w-6 items-center justify-center overflow-hidden rounded-[50%] ${
          color === 'WHITE' ? 'border border-[#00000040]' : null
        } transition  ${isActive ? 'border-text' : 'scale-[85%]'}`}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        style={{ backgroundColor }}
        type="button"
      >
        {hasImage && (
          <Image
            alt={color}
            className="absolute left-1/2 top-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 object-cover"
            height="24"
            src={swatch}
            width="24"
          />
        )}

        <div
          className={`absolute top-1/2 left-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2 rounded-[50%] border-[#FFFFFF80] transition-[border-width] duration-100 ${
            isActive ? 'border-[5px]' : 'border-[0px]'
          }`}
        />
      </button>

      {enabledColorNameOnHover && (
        <p className="pointer-events-none absolute left-[25%] bottom-[calc(100%+2px)] hidden whitespace-nowrap rounded bg-offWhite px-1 text-2xs leading-[14px] text-mediumDarkGray opacity-0 transition duration-75 md:block group-hover/color:md:opacity-100">
          {color}
        </p>
      )}
    </div>
  );
}

ColorVariantOption.displayName = 'ColorVariantOption';
